import { LocalDealer, BlackjackListener } from 'game-logic';
import { LocalRoundResultSubmitter } from '../../common/phaser/model/local-round-result-submitter';
import { LocalRoundParams, RoundParams } from '../../common/phaser/model/round-params';

export class BlackjackLocalRoundParams extends LocalRoundParams {
  public readonly dealer: LocalDealer;

  constructor(dealer: LocalDealer, localRoundResultSubmitter: LocalRoundResultSubmitter) {
    super(localRoundResultSubmitter);
    this.dealer = dealer;
  }

  public static create(gameListener: BlackjackListener): BlackjackLocalRoundParams {
    return new BlackjackLocalRoundParams(
      LocalDealer.makeRandom(),
      new LocalRoundResultSubmitter(gameListener),
    );
  }

  public static isRound(roundParams: RoundParams): roundParams is BlackjackLocalRoundParams {
    return roundParams instanceof BlackjackLocalRoundParams;
  }
}
